module.exports = __webpack_public_path__ + "static/media/propic-4.0ed9efef.png";